import { useState } from "react";
import { useLang } from "@/i18n";
import { Menu, X, Phone, Mail, Instagram } from "lucide-react";

export function Navbar() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  const links = [
    { href: "#filosofia", label: t.nav.philosophy, id: "filosofia" },
    { href: "#gallery", label: t.nav.gallery, id: "gallery" },
    { href: "#menu", label: t.nav.menu, id: "menu" },
  ];

  return (
    <header data-testid="site-navbar" className="fixed top-0 inset-x-0 z-50 bg-[#FAF9F6] border-b border-[#E5E5E5]"
            style={{ paddingTop: "env(safe-area-inset-top)", willChange: "transform" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between md:grid md:grid-cols-[1fr_auto_1fr]">
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a key={l.id} data-testid={`nav-link-${l.id}`} href={l.href}
               className="text-xs uppercase tracking-[0.2em] text-[#0A0A0A] hover:text-[#6B1E33] transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>
        <a href="#top" data-testid="nav-logo" className="flex items-center md:justify-self-center">
          <img src="/logo.png" alt="Funghetto Roma" className="h-8 w-auto" />
        </a>
        <div className="hidden md:flex items-center gap-8 justify-self-end">
          <div data-testid="lang-toggle" className="flex items-center gap-1 text-xs tracking-widest">
            <button data-testid="lang-it-btn" onClick={() => setLang("it")}
                    className={lang === "it" ? "font-bold text-[#0A0A0A]" : "text-[#999] hover:text-[#0A0A0A] transition-colors"}>IT</button>
            <span className="text-[#CCC]">/</span>
            <button data-testid="lang-en-btn" onClick={() => setLang("en")}
                    className={lang === "en" ? "font-bold text-[#0A0A0A]" : "text-[#999] hover:text-[#0A0A0A] transition-colors"}>EN</button>
          </div>
          <a href="#prenota" data-testid="nav-book-btn"
             className="text-xs uppercase tracking-[0.2em] bg-[#0A0A0A] text-[#FAF9F6] px-5 py-2.5 hover:bg-[#6B1E33] transition-colors duration-300">
            {t.nav.book}
          </a>
        </div>
        <div className="md:hidden flex items-center gap-4">
          <div data-testid="mobile-lang-toggle" className="flex items-center gap-1 text-xs tracking-widest">
            <button data-testid="nav-lang-it-btn" onClick={() => setLang("it")}
                    className={lang === "it" ? "font-bold text-[#0A0A0A]" : "text-[#999] transition-colors"}>IT</button>
            <span className="text-[#CCC]">/</span>
            <button data-testid="nav-lang-en-btn" onClick={() => setLang("en")}
                    className={lang === "en" ? "font-bold text-[#0A0A0A]" : "text-[#999] transition-colors"}>EN</button>
          </div>
          <button data-testid="mobile-menu-btn" className="p-2" aria-label={open ? t.nav.closeMenu : t.nav.openMenu}
                  onClick={() => setOpen(!open)}>
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[#E5E5E5] bg-[#FAF9F6] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.id} data-testid={`mobile-nav-link-${l.id}`} href={l.href} onClick={() => setOpen(false)}
               className="text-sm uppercase tracking-[0.2em]">{l.label}</a>
          ))}
          <div className="flex items-center gap-2 text-sm tracking-widest">
            <button data-testid="mobile-lang-it-btn" onClick={() => setLang("it")} className={lang === "it" ? "font-bold" : "text-[#999]"}>IT</button>
            <span className="text-[#CCC]">/</span>
            <button data-testid="mobile-lang-en-btn" onClick={() => setLang("en")} className={lang === "en" ? "font-bold" : "text-[#999]"}>EN</button>
          </div>
          <a href="#prenota" data-testid="mobile-book-btn" onClick={() => setOpen(false)}
             className="text-center text-xs uppercase tracking-[0.2em] bg-[#0A0A0A] text-[#FAF9F6] px-5 py-3">{t.nav.book}</a>
          <div data-testid="mobile-menu-contacts" className="border-t border-[#E5E5E5] pt-5 text-sm text-[#555] leading-loose">
            <p data-testid="mobile-menu-address">{t.footer.address}</p>
            <p>
              <a data-testid="mobile-menu-phone" href="https://wa.me/393520981771" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#6B1E33]"><Phone size={14} /> +39 352 098 1771</a><br />
              <a data-testid="mobile-menu-email" href="mailto:info@funghettoroma.it" className="inline-flex items-center gap-2 text-[#6B1E33]"><Mail size={14} /> info@funghettoroma.it</a><br />
              <a data-testid="mobile-menu-instagram" href="https://www.instagram.com/funghetto.roma" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#6B1E33]"><Instagram size={14} /> @funghetto.roma</a>
            </p>
            <p className="text-xs uppercase tracking-[0.2em]">{t.footer.everyday}</p>
          </div>
        </div>
      )}
    </header>
  );
}
